module.exports = __webpack_public_path__ + "img/warning_rhombus.baa14da9.svg";